var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_imp/3832/lib/node_modules/@core/macys-cli/node_modules/core-js/modules/_has.js
// module id = 14
// module chunks = 0